var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 offset-2 mb-5 mt-5 text-center"},[_c('h2',{staticClass:"txt-traxporta"},[_vm._v("404")]),_c('br'),_c('h4',{staticClass:"not-found"},[_vm._v("Página no encontrada")])])])])
}]

export { render, staticRenderFns }